export default __webpack_public_path__ + "phd-thesis-marias.pdf";